module.exports = __webpack_public_path__ + "static/img/icon-letter-gift-qbi.e1852fcd.png";